"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eSendEmailTo = exports.Callback = exports.eReferralTrigger = void 0;
var eReferralTrigger;
(function (eReferralTrigger) {
    eReferralTrigger["HIGH_VALUE_SHIPMENT"] = "HIGH_VALUE_SHIPMENT";
})(eReferralTrigger = exports.eReferralTrigger || (exports.eReferralTrigger = {}));
class Callback {
    constructor(url, authToken) {
        this.url = url;
        this.authToken = authToken;
    }
    static fromObj(data) {
        return new Callback(data === null || data === void 0 ? void 0 : data.url, data === null || data === void 0 ? void 0 : data.authToken);
    }
}
exports.Callback = Callback;
var eSendEmailTo;
(function (eSendEmailTo) {
    eSendEmailTo["USER"] = "USER";
    eSendEmailTo["ASSURED"] = "ASSURED";
    eSendEmailTo["BROKER"] = "BROKER";
    eSendEmailTo["QUOTE_CREATOR"] = "QUOTE_CREATOR";
    eSendEmailTo["QUOTE_RECIPIENT"] = "QUOTE_RECIPIENT";
})(eSendEmailTo = exports.eSendEmailTo || (exports.eSendEmailTo = {}));
//# sourceMappingURL=index.js.map